import Vue from 'vue'
import App from './App.vue'
import router from './router'


// 1. 引入你需要的组件
// 2. 引入组件样式
import Vant from 'vant';
import 'vant/lib/index.css'; // 引入Vant的CSS样式

Vue.use(Vant); // 使用Vant插件

Vue.config.productionTip = false

import VFormRender from 'vform-builds/dist/VFormRender.umd.min.js'  //引入VFormRender组件

import 'vform-builds/dist/VFormRender.css'  //引入VFormRender样式

Vue.use(VFormRender)  //全局注册VFormRender等组件

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
